import { get as r } from "theme-ui";
const e = {
  base: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    columnGap: 1,
    cursor: "pointer",
    borderRadius: "sm",
    fontFamily: "main",
    fontWeight: "regular",
    lineHeight: "24px",
    transition: (t) => `${r(t, "transitions.all")}, padding 0ms`,
    border: "none",
    ":hover, :active": {
      textDecoration: "none"
    },
    ":focus": {
      outline: "none"
    },
    ":focus-visible": (t) => ({
      ...t.outline({ radius: "md" })
    }),
    ":disabled": {
      cursor: "default",
      pointerEvents: "none"
    }
  },
  primary: {
    variant: "buttons.base",
    bg: "primary",
    color: "white",
    "&": (t) => ({
      ...t.hover({
        opacity: 0.8,
        bg: "primary"
        // keep background defined in hover so it won't be overwritten by responsive variants
      })
    }),
    "&:active": {
      bg: "primary",
      opacity: 1
    },
    "&:focus-visible": {
      bg: "primaryAccent"
    },
    "&:disabled": {
      bg: "lightGray3",
      color: "secondaryText"
    }
  },
  secondary: {
    variant: "buttons.base",
    bg: "secondary",
    color: "primary",
    "&": (t) => ({
      ...t.hover({
        bg: "lightGray3"
      })
    }),
    "&:focus-visible": {
      bg: "lightGray3"
    },
    "&:active": {
      bg: "secondary"
    },
    "&:disabled": {
      bg: "lightGray3",
      color: "secondaryText"
    }
  },
  ghost: {
    variant: "buttons.base",
    bg: "transparent",
    color: "primary",
    "&": (t) => ({
      ...t.hover({
        bg: "lightGray3"
      })
    }),
    "&:focus-visible": {
      bg: "lightGray3"
    },
    "&:active": {
      bg: "secondary"
    },
    "&:disabled": {
      bg: "transparent",
      color: "disabledText"
    }
  },
  white: {
    variant: "buttons.secondary",
    bg: "white"
  },
  tertiary: {
    variant: "buttons.ghost",
    border: (t) => t.border(0.25, "cardOverlay"),
    "&": (t) => ({
      ...t.hover({
        border: (o) => o.border(0.25, "lightGray3")
      })
    })
  }
}, i = {
  sm: {
    py: 1,
    px: 3,
    fontSize: "xs"
  },
  md: {
    py: (t) => t.spacing(1.5),
    px: 4,
    fontSize: "md"
  },
  lg: {
    py: 3,
    px: 6,
    columnGap: 2,
    fontSize: "md"
  }
}, n = {
  sm: {
    pl: 2
  },
  md: {
    pl: 3
  },
  lg: {
    pl: 5
  }
}, a = {
  sm: {
    pr: 2
  },
  md: {
    pr: 3
  },
  lg: {
    pr: 5
  }
}, s = {
  sm: {
    p: 1
  },
  md: {
    p: (t) => t.spacing(1.5)
  },
  lg: {
    p: 3
  }
}, c = {
  buttons: e,
  buttonSizes: i,
  buttonWithStartIconSizes: n,
  buttonWithEndIconSizes: a,
  iconButtonSizes: s
};
export {
  c as buttonsTheme
};
